import { Avatar } from '../../common/Avatar';
import { Button } from '../../common/Button';
import { Input } from '../../common/Input';
import { Spinner } from '../../components/Spinner';
import { useAuth } from '../../contexts/AuthContext';

function UserProfile(): JSX.Element {
  const { user } = useAuth();
  const { signOut } = useAuth();

  const getAvatarUrl = (): string => {
    const avatarUrl: string = (user?.user_metadata?.avatar_url as string) || '';
    if (!avatarUrl) return 'public/profile.jpeg'; // Fallback to local image
    return avatarUrl;
  };

  if (!user || !user.user_metadata) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="w-full max-w-screen-l mx-auto">
      <div className="py-5 flex flex-row justify-between items-center ">
        <h3 className="text-3xl leading-6  text-gray-900 w-full">
          User Profile
        </h3>
        <Button variant="primary" className="w-24" onClick={signOut}>
          Log Out
        </Button>
      </div>

      <div className="w-full flex flex-row items-center bg-surface-0 p-8 rounded-lg border border-border-gray">
        <div className="w-16">
          <Avatar
            src={getAvatarUrl()}
            name={(user?.user_metadata?.full_name as string) || ''}
            size="lg"
          />
        </div>
        <div className="w-1/2 px-4">
          <Input
            name="full_name"
            className="w-full"
            label="Full name"
            disabled
            value={(user?.user_metadata?.full_name as string) || ''}
          />
        </div>
        <div className="w-1/2 px-4">
          <Input
            name="email"
            className="w-full"
            label="Email address"
            disabled
            value={(user?.email as string) || ''}
          />
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
